import 'babel-polyfill';
import * as Loadable from 'react-loadable';
import * as Raven from 'raven-js';
import '@styles/index.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ROUTER_BASENAME } from '@services/lib/path';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Root from './App';
import { WKLoading } from '@components/WK/WKLoading';
import { cnzzSendObjectEvent, getPlatform } from './utils/util';

// declare const window: any;
// declare const Session: any;

// interface IaccountType {
//   id: number;
//   [key: string]: string | number;
// }

// 首次进入项目埋点，当劫持到首页的时候，首页读取window.name，识别lecture并埋点统计
function burryPoint() {
  try {
    // 由于异步加载 cnzz，可能没有加载完
    if ((window as any)._czc) {
      cnzzSendObjectEvent({
        page: 'liveroom_first_enter',
        name: `platform=${getPlatform()}`
      });
      window.name = 'wk_liveroom';
    } else {
      setTimeout(() => {
        burryPoint();
      }, 200);
    }
  } catch (error) {
    // console.log(error);
  }
}
burryPoint();

const LiveroomPage = Loadable({
  loader: () => import('./containers/Liveroom'),
  loading: WKLoading
});

const LiveroomProductsPage = Loadable({
  loader: () => import('./containers/LiveroomProducts'),
  loading: WKLoading
});

const LiveroomBoxPage = Loadable({
  loader: () => import('./containers/LiveroomBox'),
  loading: WKLoading
});

async function __main__() {
  ReactDOM.render(
    <BrowserRouter basename={ROUTER_BASENAME}>
      <Switch>
        <Root>
          <Route exact path="/:liveroomId" component={LiveroomPage} />
          <Route path="/:liveroomId/products" component={LiveroomProductsPage} />
          <Route path="/:liveroomId/box/:boxId" component={LiveroomBoxPage} />
        </Root>
      </Switch>
    </BrowserRouter>,
    document.getElementById('root') as HTMLElement
  );
}

__main__();
Raven.config('http://7c867982a3344a6185c7480d419b6780@sentry.weike.fm/49').install();



// WEBPACK FOOTER //
// ./src/index.tsx